import React, {  useContext } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';
import EvolutionStackedChartLine from './EvolutionStackedChartLine';
import HomeCollapsibleTable from './HomeCollapsibleTable';
import HomeCalendar from './HomeCalendar';
import ChildCard from '../../../components/card/ChildCard';
import { getQuantities } from '../../../services/ordersServices';
import { getShipmentRecount } from '../../../services/agendaServices';

import { userContext } from '../../../context/userContext';
import { Skeleton } from '@mui/material';
import { useQuery } from '@tanstack/react-query'
import PillsCard from '../../../components/card/PillsCard';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import {useTheme} from '@mui/material/styles'
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import BalanceIcon from '@mui/icons-material/Balance';
import ScheduleIcon from '@mui/icons-material/Schedule';
import iconDespachoProgramado from '../../../assets/iconDespachoProgramado.svg';
import iconPendienteAbierto from '../../../assets/iconPendienteAbierto.svg';
import iconPendienteEntrega from '../../../assets/iconPendienteEntrega.svg';
import iconDespachosSemana from '../../../assets/iconDespachosSemana.svg';
export default function Home() { //
  const theme = useTheme()
  const { userID, instance, accounts,company } = useContext(userContext);
  const { isLoading, isError, data } = useQuery({
    queryKey: ['TotalQuantity', 'PendingQuantity', 'OpenOrders','AssignedQuantity',company,userID],
    queryFn: () =>  getQuantities(userID, instance, accounts,company),
    staleTime: 30000,
    cacheTime: 300000,
    retry: 1,
  })
  const {
    isLoading: isLoadingAgenda,
    isError: isErrorAgenda,
    data: agendaData,
  } = useQuery({
    queryKey: ['agenda', company, userID],
    queryFn: () => getShipmentRecount(userID, instance, accounts, company),
    staleTime: 30000,
    cacheTime: 300000,
    retry: 1,
  });
 
  if (isError) {return <div><h3>No pudimos cargar la información. Reintentá en unos segundos.</h3></div>  }
  if (isErrorAgenda) {return <div><h3>No pudimos cargar los despachos programados.</h3></div>  }

  return (
    <>
      <Box sx={{ minHeight: '100vh' }}>   
          <Grid
            container
            justifyContent='space-around'
            
            columnGap={2}
          >
            <Grid sx={{display:'flex',justifyContent:'space-between' }} xs={5} columnGap={2}> 
           <PillsCard descriptionColor={'#FF9636'} 
          // icon={<LocalShippingIcon sx={{color:'white',fontSize:25}}/>}
           icon={<img
            src={iconPendienteEntrega}
            alt="icono despacho"
         //   style={{ width: 28, height: 28 }}
          />}
           title={"Pendientes de Entrega"} description={ 
              isLoading ? (
                <Skeleton
                  variant='text'
                  width={50}
                /> ): ( Number(data?.PendingQuantity / 1000)
                    .toFixed(2)
                    .replace('.', ',') + ' tns')}/>
             <PillsCard descriptionColor={'#FF9636'} 
             // icon={<PendingActionsIcon sx={{color:'white',fontSize:28}} />} 
              icon={
                <img
                  src={iconPendienteAbierto}
                  alt="icono despacho"
              //    style={{ width: 28, height: 28 }}
                />}
              title={"Pedidos Abiertos"} description={
               isLoading ? (
                <Skeleton
                  variant='text'
                  width={50}
                /> ): data?.OpenOrders}/>
                </Grid>
                <Grid sx={{display:'flex',justifyContent:'space-between' }}   xs={5} columnGap={2}>
             <PillsCard descriptionColor={'#6E726E'} 
              //icon={<BalanceIcon sx={{color:'white',fontSize:28}}/>} 
              icon={<img
                src={iconDespachoProgramado}
                alt="icono despacho"
               // style={{ width: 28, height: 28 }}
              />}
              title={"Despachos programados del día"} description={
    isLoadingAgenda
      ? <Skeleton variant="text" width={50} />
      : `${agendaData?.CountToday || 0}`
  }/>
             <PillsCard descriptionColor={'#6E726E'}  
             icon={<img
              src={iconDespachosSemana}
              alt="icono despacho"
             // style={{ width: 28, height: 28 }}
            />}
             //icon={<ScheduleIcon sx={{color:'white',fontSize:28}}/> }
              
             title={"Despachos de la semana"} description={
    isLoadingAgenda
      ? <Skeleton variant="text" width={50} />
      : `${agendaData?.CountWeek || 0}`
  }/>
             </Grid>
          </Grid>
          <Grid
            container
            marginTop='10px'
            marginBottom={'10px'}
           justifyContent={'space-around'}
            xs={12}
           columnGap={2}
          >
        <Grid xs={5} >
              <ChildCard
                title={'EVOLUCION DE DESPACHOS'}
                subheader={'Toneladas por mes'}
                color={theme.palette.card.green}
              >
                {' '}
                
                <EvolutionStackedChartLine />
              </ChildCard>
              </Grid>
              <Grid xs={5}>

              <ChildCard
                title={'AGENDA'}
                subheader={'Calendario de Pedidos y Eventos'}
                color={theme.palette.card.darkGreen}

              >
                {' '}
                <HomeCalendar  />
              </ChildCard>
              </Grid>

          </Grid>

          <Grid
            container
            marginTop='10px'
            justifyContent={'center'}
           alignItems={'center'}
            xs={12}
          >
            
            <Grid xs={11.07}>
              <ChildCard
                title={'PEDIDOS ABIERTOS'}
                //subheader={'Detalles'}
                padding={0}
                paddingContent={0}
                paddingBottom={0}
                color={theme.palette.card.orange}

              >
                {' '}
                <HomeCollapsibleTable />{' '}
              </ChildCard>{' '}
              </Grid>
          </Grid>
      </Box>
    </>
  );
}
